module.exports = __webpack_public_path__ + "img/i-accessory-black.4a54710f.svg";